import { ReduxAction, ReduxDispatch } from '../../../Configs/Redux/Types';
import {
  clearMaterialDetails,
  getMaterialBase64Finish,
  getMaterialBase64Start,
  getMaterialBase64Success,
  getMaterialFinish,
  getMaterialStart,
  getMaterialSuccess,
  getSideMenuFinish,
  getSideMenuStart,
  getSideMenuSuccess,
} from './ActionCreators';
import {
  httpGetWithDispatch,
  httpPostWithDispatch,
  httpPutWithDispatch,
} from '../../../__core/Providers/HttpClient/HttpCallerWithDispatch';
import { MaterialResponse } from '../Types/MaterialResponse';
import { SideMenuResponse } from '../Types/SideMenuResponse';
import HttpClient from '../../../__core/Providers/HttpClient/HttpClientInstance';
import { IApiJsonResponse } from '../../../__core/Interfaces/IApiResponse';

export function fetchMaterial(
  instanceId: string,
  slug: string,
  materialId: string,
  showLoader = true
): ReduxAction<Promise<unknown>> {
  const url = `material/${instanceId}/${slug}/${materialId}`;

  return (dispatch: ReduxDispatch): Promise<unknown> => {
    if (showLoader) {
      dispatch(getMaterialStart());
    }

    const successDispatch = (response: unknown): void => {
      if (showLoader) {
        dispatch(getMaterialFinish());
      }
      dispatch(getMaterialSuccess(response as MaterialResponse));
    };

    const errorDispatch = (): void => {
      dispatch(getMaterialFinish());
    };

    return httpGetWithDispatch(
      dispatch,
      url,
      null,
      successDispatch,
      errorDispatch,
      false
    );
  };
}

export function fetchPdfBase64(
  instanceId: string,
  slug: string,
  materialId: string,
  showLoader = true
): ReduxAction<Promise<unknown>> {
  const url = `material/${instanceId}/${slug}/${materialId}/read`;

  return (dispatch: ReduxDispatch): Promise<unknown> => {
    if (showLoader) {
      dispatch(getMaterialBase64Start());
    }

    const successDispatch = (response: unknown): void => {
      if (showLoader) {
        dispatch(getMaterialBase64Finish());
      }
      dispatch(getMaterialBase64Success(response as IApiJsonResponse<string>));
    };

    const errorDispatch = (): void => {
      dispatch(getMaterialBase64Finish());
    };

    return httpGetWithDispatch(
      dispatch,
      url,
      null,
      successDispatch,
      errorDispatch,
      false
    );
  };
}

export function setMaterialReview(
  materialId: string,
  instanceId: string,
  justification: string | null,
  grade: number
): ReduxAction<Promise<unknown>> {
  const url = `material/${materialId}/review`;
  const data = new FormData();

  data.append('grade', String(grade));
  data.append('instanceId', instanceId);

  if (justification) {
    data.append('justification', justification);
  }

  return (dispatch: ReduxDispatch): Promise<unknown> =>
    httpPostWithDispatch(dispatch, url, data);
}

export function setMaterialIssue(
  materialId: string,
  instanceId: string,
  message: string,
  selected: string
): ReduxAction<Promise<unknown>> {
  const url = `material/issue`;
  const data = new FormData();

  data.append('instanceId', instanceId);
  data.append('materialId', materialId);
  data.append('message', message);
  data.append('selected', selected);

  return (dispatch: ReduxDispatch): Promise<unknown> =>
    httpPostWithDispatch(dispatch, url, data);
}

export function downloadMaterial(
  id: string,
  slug: string,
  instanceId: string,
  filename: string
): ReduxAction<void> {
  const url = `material/${instanceId}/${slug}/${id}/download`;

  return (): void => {
    HttpClient.downloadFile(url, filename);
  };
}

export function fetchSideMenu(
  instanceId: string,
  slug: string,
  abortSignal: AbortSignal
): ReduxAction<Promise<unknown>> {
  const url = `menu/${slug}/${instanceId}`;

  return (dispatch: ReduxDispatch): Promise<unknown> => {
    dispatch(getSideMenuStart());

    const successDispatch = (response: unknown): void => {
      dispatch(getSideMenuFinish());
      dispatch(getSideMenuSuccess(response as SideMenuResponse));
    };

    const errorDispatch = (): void => {
      dispatch(getSideMenuFinish());
    };

    return httpGetWithDispatch(
      dispatch,
      url,
      null,
      successDispatch,
      errorDispatch,
      false,
      abortSignal
    );
  };
}

export function setArticleRead(
  instanceId: string,
  materialId: string,
  status: number
): ReduxAction<Promise<unknown>> {
  const url = `material/${instanceId}/${materialId}`;
  const data = new URLSearchParams();

  data.append('status', String(status));

  return (dispatch: ReduxDispatch): Promise<unknown> =>
    httpPutWithDispatch(dispatch, url, data);
}

export function clearMaterialData(): ReduxAction<void> {
  return (dispatch: ReduxDispatch): void => {
    dispatch(clearMaterialDetails());
  };
}
